import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { toast } from "react-toastify";

import { PageLayout } from "../../layouts/PageLayout";
import { CardLayout, EmptyState, PageHeader } from "../../components/v3";
import { EmployeeReportForm, EmployeeReportResults } from "../../components/report";

export const EmployeeReport = () => {
  const [loading, setLoading] = useState(false);
  const [reportFilters, setReportFilters] = useState(null);
  const [reportData, setReportData] = useState({});
  const [activeTab, setActiveTab] = useState("summary");
  const [paginationState, setPaginationState] = useState({ page: 0, pageSize: 10 });

  useEffect(() => {
    setReportData({});
  }, [activeTab]);

  const fetchData = async (filters, { onError } = {}) => {
    try {
      // TODO: api integration
    } catch (error) {
      onError?.();
      toast.error("Failed to generate report");
      console.error("Error fetching project report data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerate = (filters, { onError } = {}) => {
    setLoading(true);
    setReportData({});
    setReportFilters(filters);
    setPaginationState({ page: 0, pageSize: 10 });
    fetchData(
      {
        ...filters,
        page: 1,
        limit: 10,
      },
      { onError },
    );
  };

  const handlePaginationChange = (model) => {
    setPaginationState(model);
    fetchData({
      ...reportFilters,
      page: model.page + 1,
      limit: model.pageSize,
    });
  };

  const reportType = [
    { label: "Summary", onClick: () => setActiveTab("summary") },
    { label: "Details", onClick: () => setActiveTab("details") },
  ];

  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          // title
          title="Employee Report"
          chipItems={reportType}
          activeTab={activeTab}
        />
      </Box>

      {/* form section */}
      <Box sx={{ mt: -7, zIndex: 2, position: "relative" }}>
        <EmployeeReportForm
          reportType={activeTab === "summary" ? "summary" : "detailed"}
          handleClear={() => setReportData({})}
          onGenerate={handleGenerate}
        />
      </Box>

      {/* results section */}
      {!loading &&
        reportData?.count !== undefined &&
        (reportData?.count > 0 ? (
          <EmployeeReportResults
            reportType={activeTab === "summary" ? "summary" : "detailed"}
            data={reportData}
            loading={loading}
            paginationState={paginationState}
            handlePaginationChange={handlePaginationChange}
          />
        ) : (
          <CardLayout>
            <EmptyState title="No Data Found" subtitle="No report found for selected filters!" />
          </CardLayout>
        ))}
    </PageLayout>
  );
};
